




import Vue from "vue";
import Form from "../../components/Form.vue";

export default Vue.extend({
  components: {
    Form,
  },
});
